import {AxiosError, AxiosResponse} from 'axios';
import {ApiOperation, Operations} from './utilis/Api';
import {IUrlParamsType} from './utilis/Api.types';
import {request as restRequest} from './utilis/RestClient';

interface IRequestProps {
  operation: ApiOperation;
  params?: Record<string, unknown>;
  urlParams?: IUrlParamsType;
  onErrorFunction?: (Error: AxiosError) => any;
}

export const request = <T>(props: IRequestProps): Promise<AxiosResponse<T>> => {
  const {operation, params, urlParams, onErrorFunction = () => {}} = props;

  const operationObject = Operations[operation];

  const additionalParams = {
    ...(operationObject.responseType && {responseType: operationObject.responseType})
  };

  return restRequest({
    url: operationObject.url(urlParams || {}),
    method: operationObject.method,
    params: params,
    additionalParams,
    onErrorFunction: onErrorFunction,
  });
};
